import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Common from "./../../common.json";
import BulkdealsFAQ from "./BulkdealsFAQ";

const useStyles = makeStyles({
  root: {
    // minWidth: 275,
  },
});

export default function Bulkdeals() {
  let mobile = "";
  let web_token = "";
  var today = new Date(),
    ndate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [column, setcolumn] = useState(1);
  const [getRec, setgetRec] = useState(false);
  const [date, setdate] = useState(ndate);
  const [getTime, setgetTime] = useState(false);
  const [showrow, setshowrow] = useState(0);
  const [globalData, setGlobalData] = useState([]);
  const [open, setOpen] = useState(false);
  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  useEffect(() => {
    setLoading(true);
    RestService.getbulkDealsData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setGlobalData(response.data);
        setgetRec(response.data.getRec);
        setgetTime(response.data.getTime);
      },
      mobile,
      web_token,
      date,
      'bulkdeals'
    );
  }, [column, mobile, web_token, date]);

  function selectDate(e, newDate) {
    setdate(newDate.date);
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  const filterRow = (rownumber) => {
    let newval = showrow !== rownumber ? rownumber : 0;
    setshowrow(newval);
  }; 

  return (
    <>
      <GlobalHelmet {...Common?.bulkdeals} />
      <Dialog
        open={open}
        onClose={()=>setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Buy Premium Service</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This is premium service, please buy our service.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button onClick={()=>setOpen(false)} className="btn btn-default">
            Close
          </button>
          <Link to="/subscription" target="_blank" className="btn btn-success">
            Buy Now
          </Link>
        </DialogActions>
      </Dialog>
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="Bulkdeals" extraLink={"/stock-market-today/"} extraLinkText={"Market Activity"} />
              <div className={classes.root}>
                <div className=" ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabelcontiner">
                        <div className="row edit-columns">
                          <div className="col-md-6">
                            <h3>
                              <span className="highlighttext">Bulk Deals</span>
                            </h3>
                          </div>
                          <div className="col-md-3">
                            <Autocomplete
                              id="country-select-demo"
                              // style={{ width: 300 }}
                              options={getTime}
                              classes={{
                                option: classes.option,
                              }}
                              onChange={selectDate}
                              autoHighlight
                              getOptionLabel={(option) => option.date}
                              renderOption={(option) => (
                                <React.Fragment>
                                  <span>{option.date}</span>
                                </React.Fragment>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Choose Date"
                                  variant="outlined"
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: "new-password", // disable autocomplete and autofill
                                  }}
                                />
                              )}
                            />
                          </div>
                          <div className="col-md-3 text-right">
                            {parseInt(globalData?.subscription_type) > 0  ?
                          <Link className="btn btn-success" to="/bulk-deals-nse-performance" >Performance</Link>
                        :<button onClick={()=>setOpen(true)} className="btn btn-default">Performance</button>}
                            <button
                              className="btn btn-success"
                              title="Reload Page"
                              onClick={refreshPage}
                            >
                              <i className="fa fa-refresh"></i>
                            </button>
                            &nbsp;
                            <Link
                              className="btn btn-success"
                              to="/stock-market-today"
                            >
                              <i className="fa fa-arrow-left"></i>
                            </Link>
                          </div>
                        </div>

                        <div className="pl-1 pr-4 pb-4 mb-4  ">
                          {getRec ? (
                            <>
                              <table className="table table-bordered">
                                <thead>
                                  <tr className="header-row changefont">
                                    <th className="indexname" size="3">
                                      Symbol
                                    </th>
                                    <th className="ltp" size="3">
                                      LTP
                                    </th>
                                    <th className="signal" size="3">
                                      Signal
                                    </th>
                                    <th className="change" size="3">
                                      %CHG
                                    </th>
                                    <th className="change" size="3">
                                     Rec Price
                                    </th> 
                                    <th> Info </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {getRec.map((item, key) => (
                                    <>
                                      <tr key={key}>
                                        <td>{item.symbol} </td>
                                        <td>{item.ltp} </td>
                                        <td>{item.signal}</td>
                                        <td style={{ color: item.color }}>
                                          {item.cp}
                                        </td>
                                        <td>{item.rec_price}</td> 
                                        <td className="text-center">
                                          <button
                                            className="btn btm-sm btn-info"
                                            title="View More Details"
                                            onClick={(event) =>
                                              filterRow(item.bulk_deal_id)
                                            }
                                          >
                                            <i className="info-link fa fa-info"></i>
                                          </button>
                                        </td>
                                      </tr>
                                      {showrow === item.bulk_deal_id ? (
                                        <tr>
                                          <td colSpan="4">
                                            {item.child
                                              ? item.child.map((client) => (
                                                  <>
                                                    <div className="table-row">
                                                      <div className="lebel">
                                                        Client Name :
                                                        <span className="text-value">
                                                          {client.ClientName}
                                                        </span>
                                                      </div>
                                                      <div className="lebel">
                                                        Action :
                                                        <span className="text-value">
                                                          {client.action}
                                                        </span>
                                                        Trade Price :
                                                        <span className="text-value">
                                                          {client.TradePrice}
                                                        </span>
                                                        Qty :
                                                        <span className="text-value">
                                                          {
                                                            client.QuantityTraded
                                                          }
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </>
                                                ))
                                              : ""}
                                          </td>
                                        </tr>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  ))} 
                                </tbody>
                              </table>
                            </>
                          ) : (
                            ""
                          )}
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <BulkdealsFAQ/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
